import React, { useEffect, useState, useRef } from 'react'
import {
  Card,
  Modal,
  Statistic,
  List,
  Button,
  Row,
  Col,
  Input,
  Progress,
  Tabs,
  message,
  Alert,
  Rate,
  notification,
} from 'antd'
import Avatar from 'antd/lib/avatar/avatar'
import Text from 'antd/lib/typography/Text'
import 'antd/dist/antd.css'
import './DiarioVendedor.css'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { fbDatabase } from '../../firebase/firebase'
import {
  getMonth,
  getYear,
  isAfter,
  isBefore,
  set,
  startOfDay,
  startOfMonth,
} from 'date-fns'
import { endOfDay } from 'date-fns/esm'
import moment from 'moment'
import PasswordInput from './PasswordInput'
import {
  fazerReplicaAoFeedback,
  getFeedbackById,
  marcarFeedbackLido,
} from '../fila/Functions-Fila'
// `getGestorId` para filtrar `meta-acumulada` pela conta: esta tela recebe
// `empresaId` por prop, mas nunca teve o `gestorId` à mão.
import { getGestorId } from '../../components/auth/auth-provider'
import mensagem from '../../components/message/Message'
import VendedorFeedbackAlert from '../../components/Feedback/VendedorFeedbackAlert'
import confetti from 'canvas-confetti'

const { TabPane } = Tabs
const progressWidth = 100

function lerValor (valor) {
  if (valor === undefined || isNaN(Number(valor)) || valor === '') {
    return 0
  }

  return Number(valor).toFixed(2)
}

const DiarioVendedor = ({
  id,
  nome,
  empresaId,
  visible,
  vendedores,
  exigirSenhaDesempenhoVendas,
  cpf,
  feedbacksPendentes,
  user,
  onClose,
}) => {
  const canvasRef = useRef(null)
  const loading = useRef(false)

  const [record, setRecord] = useState({ feedbackText: 'Carregando...' })
  const [feedbackId, setFeedbackId] = useState('')
  const [feedbackJaFoiRespondido, setFeedbackJaFoiRespondido] = useState(false)

  const [rankingSemanal, setRankingSemanal] = useState([])
  const [rankingMensal, setRankingMensal] = useState([])
  const [totalAtendimentosNoMes, setTotalAtendimentosNoMes] = useState(0)

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [metaExiste, setMetaExiste] = useState(false)
  const [metaVerificada, setMetaVerificada] = useState(false)
  const [metaDoMes, setMetaDoMes] = useState(0)
  const [totalVendidoPeloVendedorNoMes, setTotalVendidoPeloVendedorNoMes] =
    useState(0)
  const [percentualMensalVendido, setPercentualMensalVendido] = useState(0)
  const [cpfVendedor, setCpfVendedor] = useState('')
  const [feedbackSenha, setFeedbackSenha] = useState('')
  const [feedbackAcessoPermitido, setFeedbackAcessoPermitido] = useState(false)
  const cpfFormatado = cpf.replace(/\D/g, '').substring(0, 5)
  const [tabKey, setTabKey] = useState('')

  const [responseText, setResponseText] = useState('')

  const [showConfetti, setShowConfetti] = useState(false)

  useEffect(() => {
    if (user?.id) {
      ;(async () => {
        try {
          let data = await getFeedbackById(user.id)
          if (!data) {
            data = await getFeedbackById(user.id, true)
          }

          if (!data) {
            setRecord({ feedbackText: 'Nenhum feedback encontrado.' })
            return
          }

          setFeedbackId(data.id)

          const record = {
            id: data.id,
            vendedor: { id: data.vendedor.id },
            tipoFeedback: data.tipoFeedback,
            rating: data.rating || 0,
            periodo: data.metaInfo.periodoStr,
            metaVendedor: data.vendedor.metaInfoPeriodo.meta,
            metaPorcentagemVendedor:
              data.vendedor.metaInfoPeriodo.metaPorcentagem,
            ticketMedio: data.vendedor.metaInfoPeriodo.ticketMedio,
            produtosPorAtendimento:
              data.vendedor.metaInfoPeriodo.produtosPorAtendimento,
            premioAcumulado: data.vendedor.metaInfoPeriodo.premioAcumulado,
            feedbackText:
              data.feedback.mensagem || 'Nenhum feedback fornecido.',
          }
          setResponseText(data.replica?.mensagem || '')
          const feedbackJaFoiRespondido = data.replica
            ? data.replica.mensagem !== ''
            : false
          setFeedbackJaFoiRespondido(feedbackJaFoiRespondido)
          setRecord(record)
        } catch (err) {
          console.error(err)
        }
      })()
    }
  }, [user?.id])

  const onSubmit = async response => {
    const isOk = await mensagem.confirmar(
      'Deseja enviar a resposta? Após confirmar, não será possível editá-la.',
    )
    if (isOk) {
      await fazerReplicaAoFeedback(record.id, response)
      handleOk()
      message.info('Feedback enviado com sucesso...')
    }
  }

  const onPasswordChange = e => {
    setFeedbackSenha(e)
  }

  const onTabChange = key => {
    setTabKey(key)
  }

  const onCpfChange = e => {
    const cpfInformado = e.target.value.replace(/\D/g, '')
    setCpfVendedor(cpfInformado)
  }

  const onFeedbackSenhaChange = e => {
    const senhaInformada = e.target.value.replace(/\D/g, '')
    setFeedbackSenha(senhaInformada)

    // Verifica automaticamente quando atingir 5 dígitos
    if (senhaInformada.length === 5) {
      if (senhaInformada === cpfFormatado) {
        setFeedbackAcessoPermitido(true)
        message.success('Acesso permitido!')
      } else {
        message.error('Senha incorreta!')
      }
    }
  }

  const [vendedorData, setVendedorData] = useState({
    metaPeriodo: 0,
    diasExpediente: 0,
    metaDiaria: 0,
    metaAtendimentosMensal: 0,
    atendimentos: 0,
    totalAtendimentosMes: 0,
  })

  const [historico, setHistorico] = useState({
    conversoes: 0,
    pecas: 0,
    atendimentos: 0,
    valor: 0,
  })

  const [historicoDia, setHistoricoDia] = useState({
    conversoes: 0,
    pecas: 0,
    atendimentos: 0,
    valor: 0,
  })

  let dataAtual = new Date()

  const dataInicial = startOfDay(startOfMonth(dataAtual))
  const mes = getMonth(dataInicial) + 1
  const ano = getYear(dataInicial)

  const dataRanking = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1)

  useEffect(() => {
    setIsModalVisible(visible)
  }, [visible])

  useEffect(() => {
    if (totalVendidoPeloVendedorNoMes > 0 && metaDoMes > 0) {
      const percentual = Number(
        (totalVendidoPeloVendedorNoMes / metaDoMes) * 100,
      ).toFixed(2)
      setPercentualMensalVendido(percentual)
    } else {
      setPercentualMensalVendido(0)
    }
  }, [totalVendidoPeloVendedorNoMes, metaDoMes])

  useEffect(() => {
    async function loadData () {
      loading.current = true
      const metaSnapshot = await fbDatabase
        .collection('metas')
        .where('empresaId', '==', empresaId)
        .where('ano', '==', ano)
        .where('mes', '==', mes)
        .get()

      setMetaExiste(!metaSnapshot.empty)
      setMetaVerificada(true)

      const data = metaSnapshot.empty
        ? dataRanking
        : metaSnapshot.docs[0].data().inicio.toDate()

      const rankingSnapshot = await fbDatabase
        .collection('ranking')
        .where('empresaId', '==', empresaId)
        .where('data', '>=', data)
        .get()

      const dadosRanking = rankingSnapshot.docs.map(item => item.data())

      let vendedorAvatar = ''
      let vendedorHistorico = {}
      let vendedorHistoricoDia = {}

      if (!rankingSnapshot.empty) {
        let valorTotalVendidoPeloVendedorNoMes = 0

        let rankingMens = []

        let totalAtendimentosMes = 0
        rankingSnapshot.forEach(doc => {
          const data = doc.data()

          if (data.vendedorId === id) {
            valorTotalVendidoPeloVendedorNoMes += data.atendimentos.valor
            totalAtendimentosMes += data.atendimentos.quantidade
          }

          let vendedor = rankingMens.find(item => item.id === data.vendedorId)
          if (!vendedor) {
            const vddor = vendedores.find(item => item.id === data.vendedorId)
            vendedor = {
              id: data.vendedorId,
              valor: data.atendimentos.valor,
              valorFormatado: 'R$ 0,00',
              nome: data.nome,
              avatar: vddor ? vddor.avatar : '',
            }
            rankingMens.push(vendedor)
          } else {
            debugger;
            vendedor.valor += data.atendimentos.valor
            vendedor.valorFormatado = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(vendedor.valor)
          }
        })

        debugger
        setTotalAtendimentosNoMes(totalAtendimentosMes)

        rankingMens = rankingMens.sort((a, b) => b.valor - a.valor)
        for (let i = 0; i < rankingMens.length; i++) {
          rankingMens[i].ordem = i + 1 + 'º'
        }

        setRankingMensal(rankingMens)
        setTotalVendidoPeloVendedorNoMes(valorTotalVendidoPeloVendedorNoMes)

        const reduceRanking = dadosRanking.reduce((aggr, current) => {
          const { vendedorId, atendimentos, data } = current
          const vddor = vendedores.find(item => item.id === vendedorId)
          let periodoIndex = 0

          aggr[vendedorId] = aggr[vendedorId] || {
            valor: 0,
            valorFormatado: '',
            conversoes: 0,
            pecas: 0,
            atendimentos: 0,
            nome: vddor ? vddor.apelido : '',
            avatar: vddor ? vddor.avatar : '',
          }

          if (!metaSnapshot.empty) {
            periodoIndex = metaSnapshot.docs[0]
              .data()
              .periodos.findIndex(
                periodo =>
                  isAfter(dataAtual, startOfDay(periodo.inicio.toDate())) &&
                  isBefore(dataAtual, endOfDay(periodo.fim.toDate())),
              )
          }

          if (
            metaSnapshot.empty ||
            data.toDate() >=
              metaSnapshot.docs[0].data().periodos[periodoIndex].inicio.toDate()
          ) {
            aggr[vendedorId].valor += atendimentos.valor
            aggr[vendedorId].conversoes += atendimentos.conversoes
            aggr[vendedorId].pecas += atendimentos.pecas
            aggr[vendedorId].atendimentos += atendimentos.quantidade

            debugger;
            aggr[vendedorId].valorFormatado =
              aggr[vendedorId].valor > 0
                ? new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(aggr[vendedorId].valor)
                : '-'
          }

          if (moment(data.toDate()).isSameOrAfter(moment(), 'day')) {
            vendedorHistoricoDia[vendedorId] = {
              valor: 0,
              valorFormatado: '',
              conversoes: 0,
              pecas: 0,
              atendimentos: 0,
              metaDeAtentidmentos: 0,
              nome: vddor ? vddor.apelido : '',
              avatar: vddor ? vddor.avatar : '',
            }
            vendedorHistoricoDia[vendedorId].valor = atendimentos.valor
            vendedorHistoricoDia[vendedorId].conversoes =
              atendimentos.conversoes
            vendedorHistoricoDia[vendedorId].pecas = atendimentos.pecas
            vendedorHistoricoDia[vendedorId].atendimentos =
              atendimentos.quantidade

              debugger;
            vendedorHistoricoDia[vendedorId].valorFormatado =
              vendedorHistoricoDia[vendedorId].valor > 0
                ? new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(vendedorHistoricoDia[vendedorId].valor)
                : '-'
          }

          return aggr
        }, {})

        if (!reduceRanking[id]) {
          const snapshotVendedor = await fbDatabase
            .collection('vendedores')
            .doc(id)
            .get()

          vendedorAvatar = snapshotVendedor.data().avatar
          const nomeVendedor = snapshotVendedor.data().apelido

          vendedorHistorico = {
            valor: 0,
            valorFormatado: 'R$ 0,00',
            conversoes: 0,
            pecas: 0,
            atendimentos: 0,
            nome: nomeVendedor,
            avatar: vendedorAvatar,
            totalAtendimentosMes: totalAtendimentosMes,
          }

          reduceRanking[id] = vendedorHistorico
        } else {
          vendedorAvatar = reduceRanking[id].avatar
          vendedorHistorico = reduceRanking[id]
        }

        if (!vendedorHistoricoDia[id]) {
          const snapshotVendedor = await fbDatabase
            .collection('vendedores')
            .doc(id)
            .get()

          vendedorAvatar = snapshotVendedor.data().avatar
          const nomeVendedor = snapshotVendedor.data().apelido

          vendedorHistoricoDia[id] = {
            valor: 0,
            valorFormatado: 'R$ 0,00',
            conversoes: 0,
            pecas: 0,
            atendimentos: 0,
            nome: nomeVendedor,
            avatar: vendedorAvatar,
          }
        }

        let entries = Object.entries(reduceRanking)

        entries = entries.filter(entt => {
          return entt[1].nome !== ''
        })

        const resultadoOrdenado = entries.sort(
          (a, b) => b[1].valor - a[1].valor,
        )

        let existe = false

        const ranking = resultadoOrdenado.slice(0, 3).map((item, index) => {
          existe = item[0] === id ? true : existe
          item[1].ordem = index + 1 + 'º'
          return {
            id: item[0],
            ...item[1],
          }
        })

        if (!existe) {
          reduceRanking[id].id = id
          reduceRanking[id].ordem =
            reduceRanking[id].valor === 0
              ? '... '
              : Object.values(resultadoOrdenado).findIndex(
                  item => item[0] === id,
                ) +
                1 +
                'º'
          reduceRanking[id].ordem =
            reduceRanking[id].ordem !== '... ' &&
            reduceRanking[id].ordem !== '4º'
              ? '... ' + reduceRanking[id].ordem
              : reduceRanking[id].ordem
          ranking.push(reduceRanking[id])
        }

        setRankingSemanal(ranking)
      }

      if (!metaSnapshot.empty) {
        const metaDocs = metaSnapshot.docs
        const metaData = metaDocs[0].data()

        const periodoIndex = metaData.periodos.findIndex(
          periodo =>
            isAfter(dataAtual, startOfDay(periodo.inicio.toDate())) &&
            isBefore(dataAtual, endOfDay(periodo.fim.toDate())),
        )

        const { inicio, metaPorDia, vendedorPorDia } =
          metaData.periodos[periodoIndex]
        const vendedor = {
          id: '',
          metaPeriodo: 0,
          diasExpediente: 0,
          metaDiaria: 0,
          metaDiariaFormatado: '',
          historico: {
            conversoes: 0,
            pecas: 0,
            atendimentos: 0,
            valor: 0,
          },
          historicoDia: {
            conversoes: 0,
            pecas: 0,
            atendimentos: 0,
            valor: 0,
          },
        }

        const vendedorData = metaData.vendedores.find(
          vendedor => vendedor.id === id,
        )
        vendedorData.totalVendidoPeloVendedorNoDia = 0
        vendedorData.metaDiaria = 0

        const valoresPeriodos = vendedorData.meta.periodos
        const metaMensal = valoresPeriodos.reduce(
          (total, valor) => total + valor,
          0,
        )

        setMetaDoMes(metaMensal)

        const metaPeriodo = vendedorData.meta.periodos[periodoIndex]
        const diasExpediente = vendedorData.diasExpediente[periodoIndex]

        const ticketMedio = metaDocs[0].data().objetivo.ticketMedio ?? 0

        const metaAtendimentosVendedorSemana =
          ticketMedio > 0 ? Math.ceil(metaPeriodo / ticketMedio) : 0

        const metaAtendimentosVendedorMes =
          ticketMedio > 0 ? Math.ceil(metaMensal / ticketMedio) : 0

        const metaAtendimentosMensal = metaAtendimentosVendedorMes
        const metaAtendimentosSemanal = metaAtendimentosVendedorSemana
        const dayIndex = moment().diff(moment(inicio.toDate()), 'days')

        const metaDiaria =
          metaPorDia !== undefined && dayIndex !== undefined
            ? parseFloat(metaPorDia[dayIndex] / vendedorPorDia[dayIndex])
            : 0

        const metaPeriodoFormatado = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(metaPeriodo)

        const metaDiariaFormatado = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(metaDiaria)

        const metaPorcentagem = Number(
          (vendedorHistorico.valor * 100) / metaPeriodo,
        ).toFixed(2)

        debugger
        const atendimentos = vendedorHistorico.atendimentos || 0
        const totalAtendimentosMes = totalAtendimentosNoMes || 0;

        console.log(vendedorHistorico.totalAtendimentosMes)

        const metaAtendimentosMensalPorcentagem = Number(
          (atendimentos * 100) / metaAtendimentosMensal,
        ).toFixed(2)

        const metaAtendimentosSemanalPorcentagem = Number(
          (atendimentos * 100) / metaAtendimentosSemanal,
        ).toFixed(2)

        // ─── `gestorId` para a regra por posse não rejeitar a consulta ──────
        //
        // Consulta no Firestore é tudo-ou-nada: ele NÃO recorta o resultado —
        // rejeita a consulta inteira se ela puder devolver documento que a
        // regra negaria. Sem esta linha, a meta acumulada do vendedor zera
        // silenciosamente e o diário mostra número errado, sem erro na tela.
        //
        // ⚠️ `meta-acumulada` NÃO tinha `gestorId` em produção (0% dos
        // documentos, medido em 21/09). O campo é preenchido por
        // `functions/scripts/backfill-posse.js`, derivando de
        // `metaId → metas.empresaId → empresas.gestorId`. Este filtro só
        // funciona depois que aquele script rodar.
        const gestorId = await getGestorId()

        const metaAcumuladaSnapshot = await fbDatabase
          .collection('meta-acumulada')
          .where('gestorId', '==', gestorId)
          .where('vendedorId', '==', id)
          .where('metaId', '==', metaDocs[0].id)
          .where('data', '<', startOfDay(new Date()))
          .get()

        let metaAcumulada = 0

        if (!metaAcumuladaSnapshot.empty) {
          metaAcumuladaSnapshot.docs.forEach(item => {
            const { vendido, metaDiaria } = item.data()

            if (vendido < metaDiaria) {
              metaAcumulada += metaDiaria - vendido
            } else if (vendido > metaDiaria && metaAcumulada > 0) {
              metaAcumulada =
                vendido > metaAcumulada ? 0 : metaAcumulada - vendido
            }
          })
        }

        const metaAcumuladaFormatado = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(metaAcumulada)

        debugger;
        Object.assign(vendedor, {
          atendimentos,
          totalAtendimentosMes,

          metaAtendimentosMensal,
          metaAtendimentosMensalPorcentagem,

          metaAtendimentosSemanal,
          metaAtendimentosSemanalPorcentagem,

          diasExpediente,
          metaPeriodo,
          metaPeriodoFormatado,
          metaDiaria,
          metaDiariaFormatado,
          metaDiaria,
          metaAcumulada,
          metaAcumuladaFormatado,
          metaPorcentagem,
          avatar: vendedorAvatar,
          historico: vendedorHistorico,
          historicoDia: vendedorHistoricoDia[id],
          totalVendidoPeloVendedorNoDia: vendedorHistoricoDia[id]?.valor || 0,
        })

        if (vendedor.avatar === undefined || vendedor.avatar === '') {
          vendedor.avatar = vendedorData.avatar
        }
        setVendedorData(vendedor)
        setHistorico(vendedor.historico)
        setHistoricoDia(vendedor.historicoDia)
      } else if (vendedorHistoricoDia[id] !== undefined) {
        const vendedor = vendedores.filter(vend => vend.id === id)[0]
        vendedorHistorico.valorFormatado =
          vendedorHistorico.valorFormatado ?? '-'
        vendedorHistoricoDia[id].valorFormatado =
          vendedorHistoricoDia[id].valorFormatado ?? '-'

        Object.assign(vendedor, {
          historico: vendedorHistorico,
          historicoDia: vendedorHistoricoDia[id],
        })

        setVendedorData(vendedor)
        setHistorico(vendedor.historico)
        setHistoricoDia(vendedor.historicoDia)
      }

      loading.current = false
    }

    loadData()

    // eslint-disable-next-line
  }, [])

  const handleOk = async () => {
    if (feedbackAcessoPermitido) {
      loading.current = true
      await marcarFeedbackLido(feedbackId)
    }

    onClose()

    setVendedorData({ diasExpediente: 0, metaDiaria: 0, metaPeriodo: 0 })
    setHistorico({ atendimentos: 0, conversoes: 0, pecas: 0, valor: 0 })
    setIsModalVisible(false)
  }

  useEffect(() => {
    if (
      vendedorData?.totalVendidoPeloVendedorNoDia >= vendedorData?.metaDiaria &&
      canvasRef.current
    ) {
      const myConfetti = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: true,
      })

      myConfetti({
        particleCount: 200,
        startVelocity: 30,
        spread: 360,
        origin: { x: 0.5, y: 0.5 },
      })

      notification.success({
        message: 'Parabéns!',
        description: (
          <span>
            Você atingiu a meta do dia{' '}
            <span role='img' aria-label='confetti'>
              🎉
            </span>
          </span>
        ),
        duration: 4,
      })
    }
  }, [vendedorData && vendedorData.totalVendidoPeloVendedorNoDia])

  const renderFeedbackContent = () => {
    if (!feedbackAcessoPermitido) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Alert
            style={{ marginBottom: 16 }}
            type='warning'
            showIcon
            message={
              <div>
                <strong>Acesso ao Feedback</strong>
                <div style={{ marginTop: 4 }}>
                  Lembre-se: seu feedback é confidencial. Certifique-se de
                  visualizá-lo em um momento privado.
                </div>
              </div>
            }
          />
          <label>
            Digite os 5 primeiros dígitos do seu CPF para visualizar.
          </label>

          <PasswordInput
            value={feedbackSenha}
            onChange={onPasswordChange}
            onComplete={senha => {
              if (senha === cpfFormatado) {
                setFeedbackAcessoPermitido(true)
                message.success('Acesso permitido!')
              } else {
                message.error('Senha incorreta!')
                setFeedbackSenha('') // Limpa o campo se errar
              }
            }}
          />

          {feedbackSenha.length === 5 && feedbackSenha !== cpfFormatado && (
            <p style={{ color: 'red', marginTop: '10px' }}>
              Senha incorreta! Tente novamente.
            </p>
          )}
        </div>
      )
    }

    const [vendedorTicket, lojaTicket, metaTicket] = record.ticketMedio
      .split('/')
      .map(s => s.trim())

    return (
      <div style={{ padding: '20px' }}>
        <div>
          <VendedorFeedbackAlert tipoFeedback={record.tipoFeedback} />
        </div>

        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <Rate disabled defaultValue={record.rating || 0} />
        </div>

        {/* Aqui você pode adicionar mais conteúdo sobre os feedbacks */}
        <div
          className='feedback-cards'
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '12px',
            margin: '12px 0',
          }}
        >
          {/* Card 1 - Período */}
          <Card
            title={
              <span
                style={{ fontWeight: 500, color: '#595959', fontSize: '13px' }}
              >
                Período
              </span>
            }
            bordered={true}
            headStyle={{
              borderBottom: '1px solid #f0f0f0',
              paddingTop: '4px',
              paddingBottom: '1px',
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 'auto',
              height: 'auto',
            }}
            bodyStyle={{ padding: '8px' }}
            style={{ borderRadius: '6px', border: '1px solid #e8e8e8' }}
          >
            <div style={{ textAlign: 'center' }}>
              <Statistic
                value={record.periodo}
                valueStyle={{
                  fontSize: '12px',
                  color: '#1890ff',
                  fontWeight: 500,
                }}
              />
              <div
                style={{ marginTop: '4px', color: '#8c8c8c', fontSize: '8px' }}
              ></div>
            </div>
          </Card>

          {/* Card 2 - Meta */}
          <Card
            title={
              <span
                style={{ fontWeight: 500, color: '#595959', fontSize: '13px' }}
              >
                Meta
              </span>
            }
            bordered={true}
            headStyle={{
              borderBottom: '1px solid #f0f0f0',
              paddingTop: '4px',
              paddingBottom: '1px',
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 'auto',
              height: 'auto',
            }}
            bodyStyle={{ padding: '8px' }}
            style={{ borderRadius: '6px', border: '1px solid #e8e8e8' }}
          >
            <div style={{ textAlign: 'center' }}>
              <Statistic
                value={record.metaVendedor ? record.metaVendedor : 'R$ 0,00'}
                valueStyle={{
                  fontSize: '14px',
                  color: '#ff1824',
                  fontWeight: 500,
                }}
              />
            </div>
          </Card>

          {/* Card 3 - Percentual Atingido. */}
          <Card
            title={
              <span
                style={{ fontWeight: 500, color: '#595959', fontSize: '13px' }}
              >
                Perc. Atingido
              </span>
            }
            bordered={true}
            headStyle={{
              borderBottom: '1px solid #f0f0f0',
              paddingTop: '4px',
              paddingBottom: '1px',
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 'auto',
              height: 'auto',
            }}
            bodyStyle={{ padding: '8px' }}
            style={{ borderRadius: '6px', border: '1px solid #e8e8e8' }}
          >
            <div style={{ textAlign: 'center' }}>
              <Progress
                type='circle'
                percent={
                  parseInt(
                    (record.metaPorcentagemVendedor || '0').replace(/%/g, ''),
                    10,
                  ) || 0
                }
                width={50}
                strokeWidth={10}
                strokeColor={
                  record.metaPorcentagemVendedor >= 100 ? '#52c41a' : '#1890ff'
                }
                format={percent => (
                  <span
                    style={{
                      fontSize: '14px',
                      color:
                        record.metaPorcentagemVendedor >= 100
                          ? '#52c41a'
                          : '#1890ff',
                      fontWeight: 500,
                    }}
                  >
                    {percent}
                  </span>
                )}
              />
            </div>
          </Card>

          {/* Card 4 - Ticket médio */}
          <Card
            title={
              <span
                style={{ fontWeight: 500, color: '#595959', fontSize: '13px' }}
              >
                Ticket Médio
              </span>
            }
            bordered
            headStyle={{
              borderBottom: '1px solid #f0f0f0',
              paddingTop: '4px',
              paddingBottom: '1px',
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 'auto',
              height: 'auto',
            }}
            bodyStyle={{ padding: '8px' }}
            style={{ borderRadius: '6px', border: '1px solid #e8e8e8' }}
          >
            <div style={{ textAlign: 'center' }}>
              <Statistic
                value={vendedorTicket}
                valueStyle={{
                  fontSize: '14px',
                  color: '#1890ff',
                  fontWeight: 500,
                }}
              />

              <div
                style={{
                  marginTop: '6px',
                  fontSize: '11px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  color: '#8c8c8c',
                  gap: '2px',
                }}
              >
                <div
                  style={{ display: 'flex', gap: '4px', alignItems: 'center' }}
                >
                  <span role='img' aria-label='Loja'>
                    🏬
                  </span>
                  <span>
                    <strong>Loja:</strong> {lojaTicket}
                  </span>
                </div>
                <div
                  style={{ display: 'flex', gap: '4px', alignItems: 'center' }}
                >
                  <span role='img' aria-label='Meta'>
                    🎯
                  </span>
                  <span>
                    <strong>Meta:</strong> {metaTicket}
                  </span>
                </div>
              </div>
            </div>
          </Card>

          {/* Card 5 - Peças Por Atendimento */}
          <Card
            title={
              <span
                style={{ fontWeight: 500, color: '#595959', fontSize: '13px' }}
              >
                P.A.
              </span>
            }
            bordered
            headStyle={{
              borderBottom: '1px solid #f0f0f0',
              paddingTop: '4px',
              paddingBottom: '1px',
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 'auto',
              height: 'auto',
            }}
            bodyStyle={{ padding: '8px' }}
            style={{ borderRadius: '6px', border: '1px solid #e8e8e8' }}
          >
            <div style={{ textAlign: 'center' }}>
              <Statistic
                value={record.produtosPorAtendimento?.split('/')?.[0]?.trim()}
                valueStyle={{
                  fontSize: '16px',
                  color: '#1890ff',
                  fontWeight: 500,
                }}
              />
              <div
                style={{
                  marginTop: '6px',
                  fontSize: '11px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  color: '#8c8c8c',
                  gap: '2px',
                }}
              >
                <div
                  style={{ display: 'flex', gap: '4px', alignItems: 'center' }}
                >
                  <span role='img' aria-label='Loja'>
                    🏬
                  </span>
                  <span>
                    <strong>Loja:</strong>{' '}
                    {record.produtosPorAtendimento?.split('/')?.[1]?.trim()}
                  </span>
                </div>
              </div>
            </div>
          </Card>

          {/* Card 6 - Prêmio */}
          <Card
            title={
              <span
                style={{ fontWeight: 500, color: '#595959', fontSize: '13px' }}
              >
                Prêmio
              </span>
            }
            bordered={true}
            headStyle={{
              borderBottom: '1px solid #f0f0f0',
              paddingTop: '4px',
              paddingBottom: '1px',
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 'auto',
              height: 'auto',
            }}
            bodyStyle={{ padding: '8px' }}
            style={{ borderRadius: '6px', border: '1px solid #e8e8e8' }}
          >
            <div style={{ textAlign: 'center' }}>
              <Statistic
                value={record.premioAcumulado}
                valueStyle={{
                  fontSize: '16px',
                  color: '#1890ff',
                  fontWeight: 500,
                }}
              />
              <div
                style={{ marginTop: '4px', color: '#8c8c8c', fontSize: '11px' }}
              >
                {/* {record.premioAcumulado} */}
              </div>
            </div>
          </Card>
        </div>

        <div style={{ marginTop: '1.5rem' }}>
          <label
            style={{
              fontWeight: 600,
              fontSize: '1.2rem',
              display: 'block',
              marginBottom: '0.5rem',
            }}
          >
            Feedback:
          </label>
          <div
            className='ql-container ql-snow'
            style={{
              backgroundColor: '#fafafa',
              color: '#888',
              padding: '1rem',
              borderRadius: '4px',
              overflowY: 'auto',
            }}
            dangerouslySetInnerHTML={{
              __html:
                `<style>
                img {
                  max-width: 100%;
                  height: auto;
                  border-radius: 4px;
                  margin: 0.5rem 0;
                }
              </style>` + record.feedbackText,
            }}
          />
        </div>

        <div style={{ marginTop: '1.5rem' }}>
          <label
            style={{
              fontWeight: 600,
              fontSize: '1.2rem',
              display: 'block',
              marginBottom: '0.5rem',
            }}
          >
            Deseja responder?
          </label>
          <ReactQuill
            theme='snow'
            value={responseText}
            onChange={setResponseText}
            readOnly={feedbackJaFoiRespondido}
            modules={{
              toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ header: [1, 2, 3, false] }],
                ['link'],
                ['clean'],
              ],
            }}
            formats={[
              'bold',
              'italic',
              'underline',
              'strike',
              'list',
              'bullet',
              'header',
              'link',
            ]}
            placeholder='Escreva sua resposta...'
            style={{ backgroundColor: 'white', fontSize: '1.2rem' }}
          />
        </div>

        <div
          style={{
            marginTop: '1.5rem',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '1rem',
          }}
        >
          <Button
            type='primary'
            loading={false}
            onClick={() => onSubmit(responseText)}
            disabled={
              !responseText ||
              responseText.replace(/<[^>]+>/g, '').trim().length < 10 ||
              feedbackJaFoiRespondido
            }
          >
            {feedbackJaFoiRespondido ? 'Feedback já respondido' : 'Enviar'}
          </Button>
        </div>
      </div>
    )
  }

  const modalContent = (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: 32,
        }}
      >
        <div
          style={{
            borderRadius: '50%',
            padding: 6,
            background: 'linear-gradient(135deg,rgb(32, 87, 170), #40A9FF)',
            display: 'inline-block',
          }}
        >
          <Avatar
            src={vendedorData.avatar}
            size={100}
            style={{
              border: '4px solid white',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
              borderRadius: '50%', // força o avatar a ser redondo
            }}
          />
        </div>

        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Text
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#333',
              fontFamily: 'Segoe UI, Roboto, sans-serif',
            }}
          >
            {nome}
          </Text>
        </div>
      </div>

      {metaExiste && (
        <Tabs defaultActiveKey='metadodia' onChange={onTabChange}>
          <TabPane tab='Dia' key='metadodia'>
            <div className='alerta-meta-dia-para-vendedor'>
              <Alert
                style={{ marginBottom: 16 }}
                type='warning'
                showIcon
                message={
                  <div style={{ marginTop: 4 }}>
                    Esta é a meta do dia + a meta acumulada (se houver).
                  </div>
                }
              />
            </div>

            <div
              style={{
                background: '#f9f9f9',
                padding: 24,
                borderRadius: 8,
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                marginBottom: 24,
              }}
            >
              <h5 style={{ marginBottom: 24, color: '#333' }}>
                Desempenho de Hoje
              </h5>

              <Row gutter={16}>
                <Col span={8}>
                  <Card
                    style={{
                      minHeight: 140,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        textAlign: 'center',
                      }}
                    >
                      Meta
                    </div>
                    <div style={{ fontSize: 18, color: '#000' }}>
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(vendedorData.metaDiaria || 0)}
                    </div>
                  </Card>
                </Col>

                <Col span={8}>
                  <Card
                    style={{
                      minHeight: 140,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        textAlign: 'center',
                      }}
                    >
                      Vendido
                    </div>
                    <div
                      style={{
                        fontSize: 18,
                        color:
                          vendedorData.totalVendidoPeloVendedorNoDia <
                          vendedorData.metaDiaria
                            ? '#cf1322'
                            : '#3f8600',
                        textAlign: 'center',
                      }}
                    >
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(
                        vendedorData.totalVendidoPeloVendedorNoDia || 0,
                      )}
                    </div>
                  </Card>
                </Col>

                <Col span={8}>
                  <Card
                    style={{
                      minHeight: 140,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      gap: 8,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        textAlign: 'center',
                      }}
                    >
                      Progresso
                    </div>
                    <div style={{ padding: '0 -20px' }}>
                      <Progress
                        percent={lerValor(
                          (vendedorData.totalVendidoPeloVendedorNoDia /
                            vendedorData.metaDiaria) *
                            100,
                        )}
                        strokeColor={
                          vendedorData.totalVendidoPeloVendedorNoDia <
                          vendedorData.metaDiaria
                            ? '#cf1322'
                            : '#3f8600'
                        }
                      />
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </TabPane>

          <TabPane tab='Semana' key='metadasemana'>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 24,
                marginBottom: 24,
              }}
            >
              <Col style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 12, marginBottom: 4 }}>
                  Meta de Vendas
                </div>
                <Progress
                  type='circle'
                  strokeColor='#1890ff'
                  percent={lerValor(vendedorData.metaPorcentagem)}
                  width={progressWidth}
                />
              </Col>

              <Col style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 12, marginBottom: 4 }}>
                  Atendimentos
                </div>
                <Progress
                  type='circle'
                  strokeColor='#1890ff'
                  percent={lerValor(
                    vendedorData.metaAtendimentosSemanalPorcentagem,
                  )}
                  width={progressWidth}
                  format={() =>
                    `${vendedorData.atendimentos}/${vendedorData.metaAtendimentosSemanal}`
                  }
                />
              </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Card>
                  <Statistic
                    title='Meta Semanal'
                    prefix='🎯'
                    value={vendedorData.metaPeriodoFormatado}
                    valueStyle={{ fontSize: 20 }}
                    formatter={value =>
                      typeof value === 'string'
                        ? value
                        : new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(value)
                    }
                  />
                </Card>
              </Col>

              <Col span={12}>
                <Card>
                  <Statistic
                    title='Total Vendido na Semana'
                    value={historico.valorFormatado}
                    valueStyle={{
                      color:
                        Number(
                          String(historico.valorFormatado)
                            .replace(/[^\d,]/g, '')
                            .replace(',', '.'),
                        ) <
                        Number(
                          String(vendedorData.metaPeriodoFormatado)
                            .replace(/[^\d,]/g, '')
                            .replace(',', '.'),
                        )
                          ? '#cf1322'
                          : '#3f8600',
                      fontSize: 20,
                    }}
                    prefix={
                      Number(
                        String(historico.valorFormatado)
                          .replace(/[^\d,]/g, '')
                          .replace(',', '.'),
                      ) <
                      Number(
                        String(vendedorData.metaPeriodoFormatado)
                          .replace(/[^\d,]/g, '')
                          .replace(',', '.'),
                      )
                        ? '🔻'
                        : '🔺'
                    }
                    formatter={value =>
                      typeof value === 'string'
                        ? value
                        : new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(value)
                    }
                  />
                </Card>
              </Col>
            </Row>
          </TabPane>

          <TabPane tab='Mês' key='metadomes'>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 24,
                marginBottom: 24,
              }}
            >
              <Col style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 12, marginBottom: 4 }}>
                  Meta de Vendas
                </div>
                <Progress
                  type='circle'
                  strokeColor='#1890ff'
                  percent={lerValor(percentualMensalVendido)}
                  width={progressWidth}
                />
              </Col>

              <Col style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 12, marginBottom: 4 }}>
                  Atendimentos
                </div>
                <Progress
                  type='circle'
                  strokeColor='#1890ff'
                  percent={lerValor(
                    vendedorData.metaAtendimentosMensalPorcentagem,
                  )}
                  width={progressWidth}
                  format={() =>
                    `${totalAtendimentosNoMes}/${vendedorData.metaAtendimentosMensal}`
                  }
                />
              </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Card>
                  <Statistic
                    title='Meta Mensal'
                    prefix='🎯'
                    value={metaDoMes}
                    valueStyle={{ fontSize: 20 }}
                    formatter={value =>
                      new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(value)
                    }
                  />
                </Card>
              </Col>

              <Col span={12}>
                <Card>
                  <Statistic
                    title='Total Vendido no Mês'
                    value={totalVendidoPeloVendedorNoMes}
                    valueStyle={{
                      color:
                        totalVendidoPeloVendedorNoMes < metaDoMes
                          ? '#cf1322'
                          : '#3f8600',
                      fontSize: 20,
                    }}
                    prefix={
                      totalVendidoPeloVendedorNoMes < metaDoMes ? '🔻' : '🔺'
                    }
                    formatter={value =>
                      new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(value)
                    }
                  />
                </Card>
              </Col>
            </Row>
          </TabPane>

          {typeof record && record.id !== undefined && (
            <TabPane
              tab={
                <span>
                  Feedback
                  {feedbacksPendentes > 0 && (
                    <span
                      style={{
                        marginLeft: 6,
                        backgroundColor: '#f5222d',
                        color: 'white',
                        borderRadius: '10px',
                        padding: '0 8px',
                        fontSize: '0.75rem',
                      }}
                    >
                      {feedbacksPendentes}
                    </span>
                  )}
                </span>
              }
              key='feedback'
            >
              {renderFeedbackContent()}
            </TabPane>
          )}
        </Tabs>
      )}

      {metaVerificada && !metaExiste && (
        // Sem meta o bloco acima some inteiro. Antes o vendedor não ficava
        // sabendo de nada; agora sabe por quê, e a quem cobrar.
        <Alert
          style={{ margin: '8px 0 16px' }}
          type='warning'
          showIcon
          message={
            <strong>
              Sua loja ainda não tem meta para{' '}
              {dataInicial.toLocaleDateString('pt-BR', { month: 'long' })}.
            </strong>
          }
          description='Sem meta não há acompanhamento do dia nem premiação. Fale com seu gerente.'
        />
      )}

      {tabKey !== 'feedback' && !exigirSenhaDesempenhoVendas && (
        <Tabs defaultActiveKey='rankingdomes'>
          <TabPane tab='Ranking Mês' key='rankingdomes'>
            <List
              dataSource={rankingMensal}
              renderItem={item => {
                const isCurrentUser = item.id === id
                const ordemNum = Number(item.ordem.replace('º', ''))

                const medalha =
                  ordemNum === 1
                    ? '🥇'
                    : ordemNum === 2
                    ? '🥈'
                    : ordemNum === 3
                    ? '🥉'
                    : null

                return (
                  <List.Item
                    style={{
                      backgroundColor: isCurrentUser ? '#e6f7ff' : '#fff',
                      borderRadius: 12,
                      padding: '12px 16px',
                      marginBottom: 8,
                      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar
                          src={item.avatar}
                          size={48}
                          style={{ borderRadius: '50%' }}
                        />
                      }
                      title={
                        <div
                          style={{
                            fontWeight: isCurrentUser ? 'bold' : 500,
                            color: '#143361',
                            fontSize: 16,
                          }}
                        >
                          {medalha ? `${medalha} ` : ''}
                          {`${item.ordem} - ${item.nome}`}
                        </div>
                      }
                      description={
                        <div style={{ fontSize: 14, color: '#595959' }}>
                          {item.valorFormatado}
                        </div>
                      }
                    />
                  </List.Item>
                )
              }}
            />
          </TabPane>

          <TabPane tab='Ranking Semana' key='rankingdasemana'>
            <List
              dataSource={rankingSemanal}
              renderItem={item => {
                const isCurrentUser = item.id === id
                const ordemNum = Number(item.ordem.replace('º', ''))
                const medalha =
                  ordemNum === 1
                    ? '🥇'
                    : ordemNum === 2
                    ? '🥈'
                    : ordemNum === 3
                    ? '🥉'
                    : null

                return (
                  <List.Item
                    style={{
                      backgroundColor: isCurrentUser ? '#e6f7ff' : '#fff',
                      borderRadius: 12,
                      padding: '12px 16px',
                      marginBottom: 8,
                      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar
                          src={item.avatar}
                          size={48}
                          style={{ borderRadius: '50%' }}
                        />
                      }
                      title={
                        <div
                          style={{
                            fontWeight: isCurrentUser ? 'bold' : 500,
                            color: '#143361',
                            fontSize: 16,
                          }}
                        >
                          {medalha ? `${medalha} ` : ''}
                          {`${item.ordem} - ${item.nome}`}
                        </div>
                      }
                      description={
                        <div style={{ fontSize: 14, color: '#595959' }}>
                          {item.valorFormatado}
                        </div>
                      }
                    />
                  </List.Item>
                )
              }}
            />
          </TabPane>
        </Tabs>
      )}
    </>
  )

  return (
    <Modal
      className='modal-diario-vendedor'
      open={isModalVisible}
      destroyOnClose={true}
      closable={false}
      centered
      disabled={loading.current}
      loading={loading.current}
      footer={[
        <Button key='submit' type='primary' onClick={handleOk}>
          Fechar
        </Button>,
      ]}
    >
      {/* Canvas para o confetti */}
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          width: '100%',
          height: '100%',
          zIndex: 9999,
        }}
      />

      {exigirSenhaDesempenhoVendas && cpfVendedor !== cpfFormatado ? (
        <div>
          <label>Acesso ao Ranking</label>
          <Input.Password
            style={{ width: '100%' }}
            placeholder='Digite os 5 primeiros dígitos do seu CPF'
            onChange={e => onCpfChange(e)}
            value={cpfVendedor}
            maxLength={5}
          />

          {cpfVendedor.length === 5 && cpfVendedor !== cpfFormatado ? (
            <label style={{ marginTop: '10px', color: 'red' }}>
              CPF incorreto!
            </label>
          ) : (
            ''
          )}
        </div>
      ) : (
        modalContent
      )}
    </Modal>
  )
}

export default DiarioVendedor
